<template app>
<div class="blog-post">
   <v-flex xs12 class="caption pt-1 pb-1 text-xs-left"><b>{{filters.label ? filters.label :''}}</b></v-flex>
     <v-text-field
          class="style-input mr-2 sm3"
           v-model="selected"
           outline
          v-on:change="triggerEvent"
          type="text"
          height="45px"
    />
</div>
</template>

<script>
import DropDownModel from '@/api/service/DropDownService'

  export default {
   props: ["filters","outlineBorder"],

 data () {
      return {
          selectedId:0,
        items:[]
      }
    },
    created: function() {
      
  },
   computed:{
      selected: {
        get:function() { return this.filters.default},
        set:function($val) { this.filters.default= $val}
      }
    },
  methods: {
    triggerEvent($v,$event) {
          //console.log(selected)
          console.log($v)
          //console.log($event)
          var $json ={}
          $json[this.filters.id]=$v;
          this.$emit('change',$json)

      },
      triggerEvent2($v,$event) {
          console.log($v)
          var $json ={}
          $json[this.filters.id]=$v;
          this.$emit('change',$json)

      }
      }
  }
</script>